module.exports = __webpack_public_path__ + "static/lantern_of_revealing-8b06008c35afc5fc31c3cd06f8ac5fd4.jpeg";